export const tmaisFaqsColumns = [
  { label: 'Posição', value: 'position', className: 'w-10' },
  { label: 'Pergunta', value: 'question' },
  { label: 'Ações', value: 'actions', className: 'w-10' },
]
